module.exports = __webpack_public_path__ + "assets/abef8d9a3ab06e1603226e16607c825e.png";